<template>
	<transition name="fade">
		<div v-if="modalOpen" class="modal" tabindex="-1" ref="basketModal">
			<div class="modal-dialog modal-xl">
				<div class="modal-content px-2">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalTitle }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('closeModal');" aria-label="Close"></button>
                    </div>
                    <div class="modal-body row">
                        <div class="col-12 col-sm-4">
                            <b>{{ fitter.name }}</b>
                            <span class="d-block">{{ fitter.address_line_one }}</span>
                            <span class="d-block">{{ fitter.address_line_two }}</span>
                            <span class="d-block">{{ fitter.address_line_three }}</span>
                            <b class="d-block" v-if="fitter.mobile == 0">{{ fitter.distance }} miles from you</b>
                        </div>
                        <div class="col-12 col-sm-4">
                        </div>
                        <div class="col-12 col-sm-4">
                            <b class="d-block mb-2">Your booking appointment</b>
                            <fitter-date-time
                                :fitter="fitter"
                                :mobile-fitting-slots="mobileFittingSlots"
                                :update-fitting-date="true"
                                :update-fitting-time="true"
                                :selected-fitting-date="appDate"
                                :selected-fitting-time="appTime"
                                :selected-fitting-end-time="basketAppEndTime"
                                :fittingTimes="this.fitterTimes"
                            ></fitter-date-time>
                            <div class="col-12" v-if="fitter.mobile == 1 && fitter.cal_account_number != 'CALTOTD'">
                                <p class="mb-0">The fitter will contact you with a fitting time estimate.</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <slimline-reg-size-form
                            :postcode="postcode"
                            :options="sizeOptions"
                            :image-base-path="imageBasePath"
                            :view="view"
                        ></slimline-reg-size-form>
                    </div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
    import { Form as VeeForm, Field , ErrorMessage} from 'vee-validate';
    import helpers from '@shared/mixins/helpers';

    export default {
        props: [
            'modal-open',
            'fitter',
            'sizeOptions',
            'postcode',
            'selectedAppDate',
            'selectedAppTime',
            'selectedFittingTimes',
            'mobileFittingSlots',
            'basketAppEndTime',
            'imageBasePath',
            'view'
        ],
        emits: ['closeModal'],
        components: {
            VeeForm,
            Field,
            ErrorMessage
        },
        mixins: [helpers],
        data() {
            return {
                appDate: this.selectedAppDate,
                appTime: this.selectedAppTime,
                fitterTimes: this.selectedFittingTimes,
                disabled: false
            }
        },
        mounted() {
        },
        methods: {
        },
        computed: {
            modalTitle() {
                return this.fitter.mobile == 0 ? 'Your selected fitting centre' : 'Your selected fitter';
            }
        }
    }
</script>
<style lang="scss" scoped>
    .modal {
		background-color: rgba(0,0,0,.5);
	  	display: block;
	}
</style>